import ApiCore from "./api_core"

export default new class {
    getLocation(locationID: number) {
        return ApiCore.getJson(`locations/${locationID}`)
    }

    createAddress(type: 'Village' | 'TA', name: string, parentLocation: number) {
        return ApiCore.postJson('addresses', {
            address_type: type,
            addresses_name: name,
            parent_location: parentLocation
        })
    }

    getLabs(programID: number, params={} as Record<string, string | number>) {
        return ApiCore.getJson(`programs/${programID}/lab_tests/labs`, params)
    }

    getFacilities(params={} as Record<string, string | number>) {
        return ApiCore.getJson('locations', params)
    }

    getRegions() { return ApiCore.getJson('regions') }

    getDistricts(regionID: number) {
        return ApiCore.getJson('districts', {region_id: regionID, page_size: 1000})
    }

    getVillages(traditionalAuthorityID: number, name='') {
        return ApiCore.getJson('villages', { traditional_authority_id : traditionalAuthorityID, name})
    }

    getTraditionalAuthorities(villageID: number, name='') {
        return ApiCore.getJson('traditional_authorities', { district_id: villageID, name })
    }
}
